import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
var colors = {
  up: '#15E4AB',
  down: '#FF1F5E',
  empty: '#EAEAEA'
};
export var PerformanceBars = function PerformanceBars(_ref) {
  var bars = _ref.bars,
    qty = _ref.qty;
  var qtyBars = qty || 5;
  var latest = bars.slice(0 - qtyBars);
  var barsWithoutData = latest.length === qtyBars ? [] : [0, qtyBars - latest.length - 1];
  var barWidth = 6;
  var hSpacing = 1;
  var height = 16;
  var svgWidth = qtyBars * (barWidth + hSpacing);
  var viewBox = "0 0 ".concat(svgWidth, " ").concat(height);
  return React.createElement("svg", {
    width: "34",
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, barsWithoutData.map(function (item, index) {
    return React.createElement("rect", {
      key: index,
      x: index * barWidth + index * hSpacing,
      width: barWidth,
      height: height,
      rx: "1",
      fill: colors.empty
    });
  }), latest.map(function (item, index) {
    return React.createElement("rect", {
      key: index,
      x: index * barWidth + index * hSpacing + barsWithoutData.length * barWidth + barsWithoutData.length * hSpacing,
      width: barWidth,
      height: height,
      rx: "1",
      fill: item ? colors.up : colors.down
    });
  }));
};